import React, { useEffect, useState } from 'react';
import CartTabs from './components/CartTabs';
import CustomInput from '@common/components/CustomInput';
import { inrFormat } from '@common/utils/formatCurrency';
import ProductTag from '@pages/ProductListing/view/components/ProductTag';
import { applyRemoveCoupon, cartCheckout, checkDeliveryEstimate, getAddresses, getCart, paymentVerification } from '@common/utils/cart';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Modal, Box, TextField } from '@mui/material';
import Nodata from '@common/components/NoData';
import { useDispatch } from 'react-redux';
import { openSignInModal } from 'store/slices/authSlice';
import { fetchCart, selectCartItems, selectCartPrice } from 'store/slices/cartSlice';
import { useAppSelector } from 'store/hooks';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

function Cart() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleBackdropClick = (event) => {
        // Prevent close when the backdrop is clicked
        event.stopPropagation();
    };

    const [open, setOpen] = useState(false);
    const [failedPayment, setFailedPayment] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const cartPrice = useAppSelector(selectCartPrice)

    const handleModalClose = (event, reason) => {
        // This is where you can handle close when clicking the modal button, etc.
        if (reason === 'backdropClick') {
            // Do nothing to prevent closing on backdrop click
            return;
        }
        // eslint-disable-next-line no-undef
        gtag_report_conversion("https://sansaar.co.in");
        handleClose();
        dispatch(fetchCart())
        navigate('/')
    };

    const [deliveryInputState, setDeliveryInputState] = useState(false);
    const [cartLoad, setCartLoad] = useState(false);
    const deliveryInputShowHandle = () => {
        if (deliveryInputState) {
            setDeliveryInputState(false)
        } else {
            setDeliveryInputState(true)
        }
    }

    // get cart details
    const [cartData, setCartData] = useState(null);
    const [billingAddress, setBillingAddress] = useState(null);
    const [shippingAddress, setShippingAddress] = useState(null);

    useEffect(() => {
        fetchNewCart();
        // fetchAddresses();
        // dispatch(fetchCart())
    }, []);

    const cartItems = useAppSelector(selectCartItems)
    // const cartPrice = useAppSelector(selectCartPrice)

    const fetchNewCart = async () => {
        try {
            const cart = await getCart(); // Await the promise returned by getCart
            if (cart) {
                setCartData(cart?.data);
                setCartLoad(true);
            }
        } catch (error) {
            console.error('Error fetching cart:', error);
        }
    };

    const handleApplyCoupon = async (param) => {
        try {
            const updatedCart = await applyRemoveCoupon(param); // Await the promise returned by getCart
            // console.log('cart', updatedCart);
            if (updatedCart) {
                setCartData(updatedCart?.data);
            }
        } catch (error) {
            console.error('Error update cart:', error);
        }
    }

    // console.log('cartData', cartData);

    const [tabValue, setTabValue] = useState(0);
    const handleProceed = (newTabValue) => {
        if (localStorage.getItem('isGuestUser') === "true") {
            dispatch(openSignInModal({ callback: () => handleProceedToAddress(newTabValue) }));
        } else {
            setTabValue(newTabValue);
        }
    }

    const handleProceedToAddress = async (newTabValue) => {
        // console.log('newTabValue', newTabValue);
        await fetchAddresses();
        setTabValue(newTabValue);
    }

    const placeOrder = () => {
        if (billingAddress === null || shippingAddress === null) {
            toast.error('Please select billing and shipping address');
        } else {
            handleCartCheckout();
        }
    }

    const handleCartCheckout = async () => {
        try {
            const orderStatus = await cartCheckout(shippingAddress, billingAddress); // Await the promise returned by getCart
            // console.log('orderStatus', { orderStatus });
            if (orderStatus.success === 'true' || orderStatus.success === true) {
                const { paymentOrder } = orderStatus.data;
                handlePayment(paymentOrder.id, paymentOrder.amount, paymentOrder.currency);
            }
        } catch (error) {
            console.error('Error while pacing order:', error);
        }
    }

    const handlePayment = async (order_id, amount, currency) => {
        // console.log('handlePayment', { order_id, amount, currency });
        const options = {
            // key: process.env.REACT_APP_RAZOR_PAY_ID,
            // key: "rzp_test_6pGfilc4lLBMba",
            key: "rzp_live_Vw8SjdMSMYEOxE",
            amount,
            currency,
            name: "Sansaar",
            image: "https://sansaar.co.in/static/media/logo.d3449133eb415c9b7652a3844a303205.svg",
            order_id,
            handler: async function (response) {
                const verificationResult = await paymentVerification(response.razorpay_order_id, response.razorpay_payment_id, response.razorpay_signature);
                if (verificationResult) {
                    // toast.success("Payment verified successfully!");
                    setOpen(true);
                }
            },
            modal: {
                ondismiss: async function () {
                    const verificationResult = await paymentVerification(order_id, null, null);
                    // console.log('verificationResult', { verificationResult });
                    if (!verificationResult.success === 'true' || verificationResult.success === true) {
                        toast.error("Payment Failed!");
                        setFailedPayment(true);
                        localStorage.setItem('cartData', null)
                    }
                }
            },
            notes: {
                "address": "Razorpay Corporate Office"
            },
            theme: {
                "color": "#513117"
            }
        };
        // console.log('options', options);
        const rzp1 = new window.Razorpay(options);
        rzp1.open();
    }

    const [addressData, setAddressData] = useState(null)
    useEffect(() => {
        fetchAddresses()
    }, [])

    const fetchAddresses = async () => {
        try {
            const addresses = await getAddresses() // Await the promise returned by getCart
            if (addresses) {
                setAddressData(addresses?.data)
            }
        } catch (error) {
            console.error("Error fetching address:", error)
        }
    }

    // Check delivery estimates
    const [deliveryEstimateHelperText, setDeliveryEstimateHelperText] = useState('')
    const [pinCode, setPinCode] = useState('');
    const handleCheckDelivery = (param, flowRef = '') => {
        checkDeliveryEstimate(param, setDeliveryEstimateHelperText, setDeliveryInputState)
    }

    useEffect(() => {
        if (deliveryEstimateHelperText === '') {
            if (localStorage.getItem('selected_pincode')) {
                setPinCode(localStorage.getItem('selected_pincode'));
                handleCheckDelivery(localStorage.getItem('selected_pincode'));
            } else if (addressData?.length > 0) {
                let tempPinCode = addressData.find((item) => item.isDefault)?.pincode;
                setPinCode(tempPinCode);
                localStorage.setItem('selected_pincode', tempPinCode);
                handleCheckDelivery(tempPinCode);
            }
        }
    }, [addressData])

    useEffect(() => {
        if (shippingAddress !== null) {
            const selectedAdd = addressData.find((address) => address.id === shippingAddress);
            if (selectedAdd) {
                localStorage.setItem('selected_pincode', selectedAdd?.pincode);
                handleCheckDelivery(selectedAdd?.pincode);
                setPinCode(selectedAdd?.pincode)
            }
        }
    }, [shippingAddress])
    // console.log('billingAddress', billingAddress, shippingAddress, deliveryEstimateHelperText);
    // console.log('proceed condition', (!billingAddress || !shippingAddress || !(deliveryEstimateHelperText !== 'Pincode is not servicable' && deliveryEstimateHelperText !== '')))
    return (
        <>
            <div className='bs-section'>
                <div className='lyt-cart'>
                    {cartItems !== null ? (<>
                        {cartItems?.length > 0 ? (<>
                            <div className='lyt-cart__tabs-wrap'>
                                <CartTabs
                                    data={cartItems}
                                    setCartData={setCartData}
                                    tabValue={tabValue}
                                    setTabValue={setTabValue}
                                    setShippingAddress={setShippingAddress}
                                    setBillingAddress={setBillingAddress}
                                    billingAddress={billingAddress}
                                    shippingAddress={shippingAddress}
                                    addressData={addressData}
                                    setAddressData={setAddressData}
                                    fetchAddresses={fetchAddresses}
                                />
                            </div>
                            <div className='lyt-cart__summary-wrap'>
                                <ul className='lyt-cart__summary-item-wrap'>
                                    <li className='lyt-cart__summary-item'>
                                        <div className='bs-card bs-card--typ-border bs-card--typ-flex'>
                                            <div className='bs-card__info-wrap'>
                                                <div className='bs-card__title-wrap'>
                                                    <label className='bs-card__title'><span className='bs-card__title--bold'>delivering to</span> {!deliveryInputState ? localStorage.getItem('selected_pincode') : ''}</label>
                                                    {(!deliveryInputState && tabValue !== 1) && <button className='bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline' onClick={deliveryInputShowHandle}><span className='bs-btn__btn-text'>change</span></button>}
                                                </div>
                                            </div>
                                            <div className='bs-card__action-wrap'>
                                                {!deliveryInputState ? (
                                                    <p className='bs-card__desc'>{deliveryEstimateHelperText}</p>
                                                ) : (
                                                    <CustomInput
                                                        helperText={deliveryEstimateHelperText}
                                                        iconName='icon-delivery'
                                                        inputData={pinCode || ''}
                                                        handleBtnClick={handleCheckDelivery}
                                                    // reference="deliveryode"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                    {/* <li className='lyt-cart__summary-item'>
                                        <div className='bs-card bs-card--typ-border'>
                                            <div className='bs-card__info-wrap'>
                                                <label className='bs-card__title'><span className='bs-card__title--semi-bold'>apply coupon</span></label>
                                            </div>
                                            <div className='bs-card__action-wrap'>
                                                <CustomInput
                                                    helperText={`Congratulations, you have saved <span class="cm-text-bold">${inrFormat(cartData?.price?.discount)}</span>`}
                                                    iconName='icon-tag'
                                                    inputData={cartData?.price?.couponCode || ''}
                                                    couponSaving={cartData?.price?.discount || ''}
                                                    handleBtnClick={handleApplyCoupon}
                                                    reference="coupon"
                                                    readOnly={tabValue === 0 ? false : true}
                                                />
                                            </div>
                                        </div>
                                    </li> */}
                                    <li className='lyt-cart__summary-item'>
                                        <div className='bs-card bs-card--typ-bg bs-order-summary'>
                                            <div className='bs-card__info-wrap'>
                                                <div className='bs-order-summary__details-wrap'>
                                                    <label className='bs-card__title bs-order-summary__title'><span className='bs-card__title--bold'>order summary</span></label>
                                                    <ul className='bs-order-summary__list'>
                                                        <li className='bs-order-summary__item'>
                                                            <label className='bs-order-summary__label'>order total</label>
                                                            <p className='bs-order-summary__value'>{inrFormat(cartPrice?.price)}</p>
                                                        </li>
                                                        {/* <li className='bs-order-summary__item'>
                                                    <label className='bs-order-summary__label'><ProductTag title={calculateDiscountPercentage(Number(cartData?.price?.discount), Number(cartData?.price?.price))} classname="bs-cart-item__tag"/>Discount on MRP</label>
                                                    <p className='bs-order-summary__value'>-{inrFormat(600)}</p>
                                                </li> */}
                                                        {Number(cartData?.price?.discount) > 0 && <li className='bs-order-summary__item'>
                                                            <label className='bs-order-summary__label'>Coupon Discount</label>
                                                            <p className='bs-order-summary__value'>-{inrFormat(cartPrice?.discount)}</p>
                                                        </li>}
                                                        {/* <li className='bs-order-summary__item'>
                                                    <label className='bs-order-summary__label'>Estimated Taxes</label>
                                                    <p className='bs-order-summary__value'>{inrFormat(1600)}</p>
                                                </li>
                                                <li className='bs-order-summary__item'>
                                                    <label className='bs-order-summary__label'>Shipping charges</label>
                                                    <p className='bs-order-summary__value'>{inrFormat(1600)}</p>
                                                </li> */}
                                                        <li className='bs-order-summary__item bs-order-summary__item--total'>
                                                            <label className='bs-order-summary__label bs-card__title bs-card__title--bold'>total amount</label>
                                                            <p className='bs-order-summary__value'>{inrFormat(cartPrice?.finalPrice)}</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='bs-card__action-wrap'>
                                                <button
                                                    className="bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl"
                                                    // disabled={(tabValue === 0 && cartData?.cartItem.length === 0) || (tabValue === 1 && (!billingAddress || !shippingAddress || !(deliveryEstimateHelperText !== 'Pincode is not servicable' && deliveryEstimateHelperText !== '')))} // Disable if tabValue is 1 and addresses are null
                                                    disabled={(tabValue === 0 && cartData?.cartItem.length === 0) || (tabValue === 1 && (!billingAddress || !shippingAddress))} // Disable if tabValue is 1 and addresses are null
                                                    onClick={() => {
                                                        tabValue === 0 ? handleProceed(1) : placeOrder();
                                                    }}
                                                >
                                                    {tabValue === 2 ? 'place order' : 'proceed'}
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </>) : cartItems?.length === 0 ?
                            <Nodata visible={true} />
                            : null}
                    </>) : <> Loading... </>}
                </div>
            </div>
            <Modal
                open={open}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='bs-modal bs-modal--typ-select-address'

            >
                <Box className='bs-modal__wrapper' sx={style} onClick={handleBackdropClick}>
                    <div className="bs-success-msg">
                        <div className='bs-success-msg__info-wrap'>
                            <span className='icon icon-success bs-success-msg__icon'></span>
                            <h4 className='bs-success-msg__title'>Order placed successfully</h4>
                            <p className='bs-success-msg__desc'>Thank you for shopping at <span className='cm-line-break'>Sansaar, a D’Décor brand</span></p>
                        </div>
                        <div className='bs-success-msg__action-wrap'>
                            <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' onClick={handleModalClose}>continue shopping</button>
                        </div>
                    </div>
                </Box>
            </Modal>
            <Modal
                open={failedPayment}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='bs-modal bs-modal--typ-select-address'

            >
                <Box className='bs-modal__wrapper' sx={style} onClick={handleBackdropClick}>
                    <div className="bs-success-msg">
                        <div className='bs-success-msg__info-wrap'>
                            <span className='icon icon-fail bs-success-msg__icon'></span>
                            <h4 className='bs-success-msg__title'>Order not placed</h4>
                            <p className='bs-success-msg__desc'>Your order couldn’t be completed.</p>
                            <p className='bs-success-msg__order-details'>
                                {/* <span className='bs-success-msg__order-details bs-success-msg__order-details--highlight'>Order ID : </span>123456789098765 */}
                            </p>
                        </div>
                        <div className='bs-success-msg__action-wrap'>
                            {/* <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' onClick={handleModalClose}>retry</button> */}
                            <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-btn__btn-solid--inverse-border' onClick={handleModalClose}>go back</button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default Cart